import styled from '../../../utils/styling/styled';

import ScrollSection from '../../ScrollSection';
import StaticPageHeadline from '../../StaticPageItems/StaticPageHeadline';
import styleUtils from '../../../utils/styling/styleUtils';
import { decidePaddingLeftLandscapeSmall, decidePaddingRightLandscape, removeTopMarginIfMultipleChildren } from '../utils';

// Types
import { FluidImage } from '../../MediaImage/GatsbyImageWrapperFluid/GatsbyImageWrapperFluid';
import { ReactNode } from 'react';
import { SectionWidth } from '../../../../types/sections';

export const Content = styled.div`
  margin-left: auto;
  margin-right: auto;

  ${styleUtils.media.orientation.landscape} {
    max-width: 50vw;
  }

  ${styleUtils.media.orientation.portrait} {
    max-width: 90vw;
  }
`;

export const Headline = styled(StaticPageHeadline)`
  color: ${props => props.theme.color.brand};
`;

type SectionProps = {
  backgroundColor: string | null;
  backgroundImage: FluidImage | null;
  children: ReactNode;
  contentPositionX: string;
  contentPositionY: string;
  index: number;
  isClipped?: boolean;
  isNeighborClipped?: boolean;
  sectionWidth: SectionWidth;
};

export const Section = styled(ScrollSection)<SectionProps>`
  display: flex;

  ${decidePaddingLeftLandscapeSmall};
  ${decidePaddingRightLandscape};
  ${removeTopMarginIfMultipleChildren};

  ${styleUtils.media.orientation.landscape} {
    ${styleUtils.padding.horizontal.both};
    ${styleUtils.padding.vertical.bothQuadruple};

    flex-direction: column;
  }

  ${styleUtils.media.orientation.portrait} {
    ${styleUtils.padding.horizontal.both};
    ${styleUtils.padding.vertical.bothDouble};

    /* Flex Container */
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;

    ${styleUtils.specificity.increaseSpecificity} {
      min-height: auto !important;
    }
  }
`;

export const Background = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
`;
